export default __webpack_public_path__ + "static/media/bg-value-Advancements.5d530ea1.jpg";